import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEdit3, FiLayout, FiShield, FiArrowRight } = FiIcons;

const PaymentFlow = () => {
  const scrollToPayment = () => {
    const element = document.getElementById('payment');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const steps = [
    {
      number: "1",
      icon: FiEdit3,
      title: "Submit Your Enquiry",
      description: "Tell us your trade, services and area so we understand your needs."
    },
    {
      number: "2",
      icon: FiLayout,
      title: "Review Your Custom Plan",
      description: "We analyse your business and send a tailored landing page plan."
    },
    {
      number: "3",
      icon: FiShield,
      title: "Build + First Draft",
      description: "Once approved, we produce your first version within 3 business days."
    },
    {
      number: "4",
      icon: FiShield,
      title: "First Revision Guarantee",
      description: "If the first revision is not aligned, you can walk away for a full refund."
    }
  ];

  return (
    <section id="payment-flow" className="py-20 bg-gradient-to-br from-gray-900 to-black overflow-hidden border-t border-white/5">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Simple Enquiry Process
          </h2>
          <div className="flex items-center justify-center gap-2 text-white/50 text-sm">
            <span>No obligation. Just a clear plan for your business.</span>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-4 gap-6 relative mb-12">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-px border-t border-dashed border-white/10 -translate-y-12"></div>

          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.2, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="relative z-10 bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 flex flex-col items-center text-center group hover:bg-white/10 transition-all duration-200"
            >
              <div className="absolute -top-3 -left-3 w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg">
                {step.number}
              </div>
              <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-200">
                <SafeIcon icon={step.icon} className="w-6 h-6 text-blue-400" />
              </div>
              <h3 className="text-white font-bold mb-2">{step.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={scrollToPayment}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-4 rounded-lg font-semibold hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-xl"
          >
            Request My Plan
            <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default PaymentFlow;